import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselContainerFn = /* @__PURE__ */ createRecipe('carousel-container', {}, [])

const carouselContainerVariantMap = {}

const carouselContainerVariantKeys = Object.keys(carouselContainerVariantMap)

export const carouselContainer = /* @__PURE__ */ Object.assign(memo(carouselContainerFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselContainer',
  __getCompoundVariantCss__: carouselContainerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselContainerVariantKeys,
  variantMap: carouselContainerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselContainerVariantKeys)
  },
  getVariantProps: carouselContainerFn.getVariantProps,
})